module.exports = __webpack_public_path__ + "static/media/30-t.ff453c56.png";